import { get, map } from "lodash";
import { SET_USER_PROFILE, SIGN_OUT, SET_SESSION_ID } from "../types";
import getJwt from "../../utils/getJwt";
import { API } from "aws-amplify";

export const setUserProfile = (profile) => ({
  type: SET_USER_PROFILE,
  payload: profile,
});

export const signOut = () => ({
  type: SIGN_OUT,
});

export const setSessionId = (sessionId) => ({
  type: SET_SESSION_ID,
  sessionId
})

export const handleNewsletterSubscriptions =
  (newsletters, user) => async (_dispatch, getState) => {
    try {
      const { userId } = user;
      const jwt = await getJwt();
      const locale = get(getState(), ["i18n", "locale"], "en");

      const normalizedNewsletters = map(
        newsletters,
        ({ category, status }) => ({
          category,
          status,
          locale,
        })
      );

      const headers = { Authorization: `Bearer ${jwt}` };
      const body = normalizedNewsletters;
      const params = {
        body,
        headers,
      };
      await API.put("users", `/users/${userId}/communications`, params);
    } catch (error) {
      console.log("An error occurred", error);
    }
  };
